module.exports = __webpack_public_path__ + "static/media/cardapio.07709bcb.jpeg";